export const removeColon = (time: string) => {
  return time.replace(":", "");
};
